import React from 'react';
import classNames from 'classnames';
import useTranslation from 'utils/hooks/useTranslation';
import { formatTopUpDetail } from 'pages/Wallet/helper';

import styles from './style.module.scss';

const LastTopUp = ({ amount, date, paymentMethod, inactive = false }) => {
  const { translateText } = useTranslation();
  const hasTopUp = Boolean(amount);
  const detail = hasTopUp ? formatTopUpDetail({ date, paymentMethod }, translateText) : null;

  return (
    <div
      className={classNames(styles.statCard, { [styles.statCardInactive]: inactive })}
      data-testid="walletLastTopUp"
    >
      <div className={styles.statHeader}>
        <span className={styles.statLabel}>
          {translateText('corporateAccounts.wallet.dashboard.lastTopUp.label')}
        </span>
      </div>
      <div className={`${styles.statValue} ${styles.statValueSmall}`}>
        {hasTopUp ? amount : '—'}
      </div>
      <div className={`${styles.statSub} ${styles.statSubTight}`}>
        {hasTopUp ? detail : translateText('corporateAccounts.wallet.dashboard.lastTopUp.none')}
      </div>
    </div>
  );
};

export default LastTopUp;
